<ng-container *ngTemplateOutlet="flightOffer?.flight?.outbound ? flugSimple : flugNull">
</ng-container>
<ng-template #flugSimple>
    <div class="f-wrappper">
        <div class="ccc1" [class.flgwrapper-mobile]="desktopTemplate === 'xs' || desktopTemplate === 'sm'">
            <ng-container *ngIf="myflight?.outbound">
                <div class="f-body">
                    <div class="f-header-wrapper">
                        <mat-icon  class="f-ico rotate">flight</mat-icon>
    
                        <span class="ml3">{{myflight?.outbound?.departureDateWeek}} {{myflight.outbound.departureDate |
                            date}}</span>
    
                        <ng-container *ngIf="myflight?.outbound?.directFlug">
                            <span class="ml3"> &minus; Direktflug</span>
                        </ng-container>
    
                        <ng-container *ngIf="!myflight?.outbound?.directFlug">
                            <span class="ml3"> &minus; {{myflight?.outbound?.stopovers}} Stop</span>
                        </ng-container>
                    </div>
    
    
                    <div class="f-info-wr">
                        <div class="f-info-body w50p">
                            <span>{{myflight?.outbound?.departureTime}}</span>
                            <span>{{myflight?.outbound?.arrivalTime}}<sup>{{(myflight.outbound.differenceInDays?.length > 0
                                    ? '+' +
                                    this.myflight.outbound.differenceInDays : '')}}</sup></span>
    
                        </div>
                        <div class="ficowr">
                            <mat-icon class="i1-ico"> lens</mat-icon>
                            <div class="divider"></div>
                            <mat-icon class="i1-ico"> lens</mat-icon>
                        </div>
                        <div class="f-info-body">
                            <span>{{myflight?.outbound?.departureAirportName}}
                                ({{myflight?.outbound?.departureAirportCode}})</span>
    
                                <span class="ftime">
                                    {{myflight?.outbound?.estimatedElapsedTime}} Std.
                                </span>
    
    
                            <span>{{myflight?.outbound?.arrivalAirportName}}
                                ({{myflight?.outbound?.arrivalAirportCode}})</span>
                        </div>
                    </div>
    
                </div>
            </ng-container>
    
            <ng-container *ngIf="myflight?.inbound && mode === 'flight'">
                <div class="f-body" [class.mt1]="desktopTemplate === 'xs' || desktopTemplate === 'sm'">
                    <div class="f-header-wrapper">
                        <mat-icon  class="f-ico rmin">flight</mat-icon>
    
                        <span class="ml3">{{myflight?.inbound?.departureDateWeek}} {{myflight.inbound.departureDate |
                            date}}</span>
    
                        <ng-container *ngIf="myflight?.inbound?.directFlug">
                            <span class="ml3"> &minus; Direktflug</span>
                        </ng-container>
    
                        <ng-container *ngIf="!myflight?.inbound?.directFlug">
                            <span class="ml3"> &minus; {{myflight?.inbound?.stopovers}} Stop</span>
                        </ng-container>
                    </div>
    
    
                    <div class="f-info-wr">
                        <div class="f-info-body w50p">
                            <span>{{myflight?.inbound?.departureTime}}</span>
                            <span>{{myflight?.inbound?.arrivalTime}}<sup>{{(myflight.inbound.differenceInDays?.length > 0
                                    ? '+' +
                                    this.myflight.inbound.differenceInDays : '')}}</sup></span>
    
                        </div>
                        <div class="ficowr">
                            <mat-icon class="i1-ico"> lens</mat-icon>
                            <div class="divider"></div>
                            <mat-icon class="i1-ico"> lens</mat-icon>
                        </div>
                        <div class="f-info-body">
                            <span>{{myflight?.inbound?.departureAirportName}}
                                ({{myflight?.inbound?.departureAirportCode}})</span>
    
                                <span class="ftime">
                                    {{myflight?.inbound?.estimatedElapsedTime}} Std.
                                </span>
    
    
                            <span>{{myflight?.inbound?.arrivalAirportName}}
                                ({{myflight?.inbound?.arrivalAirportCode}})</span>
                        </div>
                    </div>
    
                </div>
            </ng-container>
        </div>

        <button class="dbtn" (click)="openFluginfo()" matRipple>
            <span>Flugdetail</span>
        </button>
    </div>
</ng-template>

<ng-template #flugNull>
    <div class="f2gwr">
        <ng-container *ngIf="flightOffer" [ngTemplateOutlet]="fliugsAiports"></ng-container>
        <div class="f22er">
            <div class="f2wr">
                <mat-icon  class="f2ico">
                    warning
                </mat-icon>
                <span class="f22t">Flugdetail noch nicht verfügbar</span>
            </div>
            <span class="f2t">bitte auf Angebot auf prüfen
                klicken</span>
        </div>
    </div>
</ng-template>

<ng-template #fliugsAiports>
    <div class="f1wr">
        <span>{{flightOffer?.flight?.departureAirport?.name}}
            ({{flightOffer?.flight?.departureAirport?.code}})</span>
        <mat-icon  class="f1ico">
            sync_alt</mat-icon>
        <span>{{flightOffer?.flight?.arrivalAirport?.name}}
            ({{flightOffer?.flight?.arrivalAirport?.code}})</span>
    </div>
</ng-template>